import General from './general';
import Query from './query';
import TransactionRequest from './transactionRequest';

const APIs = {
  General,
  Query,
  TransactionRequest,
};

export default APIs;
